<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="BaAddendum"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] BA Addendum
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.REVISED&& header.Status != this.$APPROVAL_STATUS.DONE)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">

                            <!-- <FormField :labelName="$t('date_place')" fieldName="Date_Place" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Date_Place" v-model="header.Date_Place" required="true" type="text"
                                    :placeholder="$t('date_place')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    <small v-if="header && !header.Date_Place && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('date_place')) }}
                                     </small>
                            </FormField> -->

                            
                            <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('doc_date')" fieldName="Doc_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="doc_date" v-model="header.Doc_Date" type="text"
                                :placeholder="$t('doc_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Doc_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('doc_date')) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('company')" fieldName="Company_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Company_Code" :filter="true"  v-if="header"
                                    v-model="header.Company_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/company_Code'"
                                    :minLength="0"
                                    :params="{ docDate: (header.Doc_Date)}" 
                                    :disabled="true"
                                    />
                                    <small v-if="header && !header.Company_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                     :params="{ docDate: (this.header.Created_Date != null ? this.header.Created_Date  : null)}"  
                                    :disabled="true"
                                    />
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('work')" fieldName="Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Pekerjaan" v-model="header.Pekerjaan" required="true" type="text"
                                    :placeholder="$t('work')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Pekerjaan && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('work')) }}
                                     </small>
                            </FormField>

                            <div class="field grid">
                                <label for="No_Kontrak" class="col-4">{{ $t('contract_no') }}</label>
                                <div class="col-6 md-6">
                                    <InputText name="No_Kontrak" v-model="header.No_Kontrak" type="text" :placeholder="$t('contract_no')"
                                        v-if="header"
                                        :disabled="true"/>
                                    <Skeleton v-else-if="!header" />
                                    <!-- <small v-if="header && (!header.No_Kontrak && !header.isWithOutSpo) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('contract_no')) }}
                                    </small> -->
                                </div>
                            </div>
                            
                            <div class="field grid">
                                <label for="Persentase_Actual_Awal" class="col-4">{{ $t('initial_actual_percentage')}} (%)</label>
                                <div class="col-6 md-6">
                                    <InputNumber name="Persentase_Actual_Awal" v-model="header.Persentase_Actual_Awal" type="text" :placeholder="$t('initial_actual_percentage')"
                                        v-if="header"
                                        :disabled="header.Type_Persentase != 'Cut Off'|| (mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT)" :useGrouping="false" max="100"/>
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Persentase_Actual_Awal && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('initial_actual_percentage')) }}
                                    </small>
                                </div>
                            </div>

                            <FormField :labelName="$t('type_Persentase')" fieldName="Type_Persentase" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <div class="flex flex-wrap gap-3">
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Type_Persentase" name="Type_Persentase" :value="'Penambahan'" v-if="header" @change="onChangeTypePersentase()" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                        <label for="Persentase_PP" class="ml-2 mr-2">Penambahan</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Type_Persentase" name="Type_Persentase" :value="'Pengurangan'"  v-if="header" @change="onChangeTypePersentase()" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                        <label for="Persentase_PP" class="ml-2">Pengurangan</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Type_Persentase" name="Type_Persentase" :value="'Cut Off'"  v-if="header" @change="onChangeTypePersentase()" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                        <label for="Persentase_PP" class="ml-2">Cut Off</label>
                                    </div>
                                </div>

                                    <small v-if="header && !header.Type_Persentase && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('type_Persentase')) }}
                                    </small>
                            </FormField>

                            <div class="field grid">
                                <label for="Persentase_PP" class="col-4">{{ $t('persentase_pp')}} (%)</label>
                                <div class="col-6 md-6">
                                    <InputNumber name="Persentase_PP" v-model="header.Persentase_PP" type="text" :placeholder="$t('persentase_pp')"
                                        v-if="header" mode="decimal" :maxFractionDigits="2"
                                        :disabled="true" :useGrouping="false"/>
                                        <!-- mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Type_Persentase == 'Cut Off' -->
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && header.Persentase_PP == null && header.Type_Persentase != 'Cut Off' && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('persentase_pp')) }}
                                    </small>
                                </div>
                            </div>

                            <!-- (mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || header.Type_Persentase != 'Cut Off' -->
                            <FormField :labelName="$t('persentase_cut_off')" fieldName="Persentase_Cut_Off" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Persentase_Cut_Off" v-model="header.Persentase_Cut_Off" type="text" :placeholder="$t('persentase_cut_off')"
                                    v-if="header" :disabled="true" 
                                    :useGrouping="false" max="100"  v-tooltip.bottom="$t('messagebox.cutoff')" :maxFractionDigits="2"/>
                                <small v-if="header && !header.Persentase_Cut_Off && header.Type_Persentase == 'Cut Off' && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('persentase_cut_off')) }}
                                </small>
                            </FormField>
                        </div>  
                        <div class="col-6">
                            
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('initial_value_contract')" fieldName="Nilai_Awal_Kontrak" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Nilai_Awal_Kontrak" v-model="header.Nilai_Awal_Kontrak" required="true" type="text" :useGrouping="true" :minFractionDigits="2"
                                    :placeholder="$t('initial_value_contract')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Nilai_Awal_Kontrak && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('initial_value_contract')) }}
                                    </small>
                            </FormField>

                            <!-- <FormField :labelName="$t('type_nilai')" fieldName="Type_Nilai" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <div class="flex flex-wrap gap-3">
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Type_Nilai" name="Nilai_PP" :value="'Penambahan'" v-if="header" @change="onChangeTypeNilai()"/>
                                        <label for="Type_Nilai" class="ml-2 mr-2">Penambahan</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Type_Nilai" name="Nilai_PP" :value="'Pengurangan'"  v-if="header" @change="onChangeTypeNilai()"/>
                                        <label for="Type_Nilai" class="ml-2">Pengurangan</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Type_Nilai" name="Nilai_PP" :value="'Cut Off'"  v-if="header" @change="onChangeTypeNilai()"/>
                                        <label for="Nilai_PP" class="ml-2">Cut Off</label>
                                    </div>
                                </div>
                                    <small v-if="header && !header.Type_Nilai && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('type_nilai')) }}
                                    </small>
                            </FormField> -->

                            <FormField :labelName="$t('nilai_pp')" fieldName="Nilai_PP" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <!-- <InputNumber name="Nilai_PP" v-model="this.Nilai_PP" required="true" type="text" :useGrouping="true" :minFractionDigits="2"
                                    :placeholder="$t('nilai_pp')" v-if="header && header.Type_Persentase == 'Cut Off'" :maxFractionDigits="2"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Type_Persentase == 'Cut Off'" />
                                    <small v-if="header && !this.Nilai_PP && submitted && mode != this.$FORM_MODE_DELETE && header.Type_Persentase == 'Cut Off'"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('nilai_pp')) }}
                                    </small> -->
                                  
                                    <InputNumber name="Nilai_PP" v-model="this.header.Nilai_PP" required="true" type="text"  :useGrouping="true" :minFractionDigits="2" 
                                        :placeholder="$t('nilai_pp')" v-if="header /*&& header.Type_Persentase != 'Cut Off'*/ " :maxFractionDigits="2"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" @input="inputNilaiPP($event)" @blur="inputNilaiPP($event)"/>
                                    <small v-if="header && this.header.Nilai_PP == null && submitted && mode != this.$FORM_MODE_DELETE /*&& header.Type_Persentase != 'Cut Off'*/"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('nilai_pp')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('final_value_contract')" fieldName="Nilai_Akhir_Kontrak" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Nilai_Akhir_Kontrak" v-model="header.Nilai_Akhir_Kontrak" required="true" type="text"
                                    :placeholder="$t('final_value_contract')" v-if="header"  :useGrouping="true" :minFractionDigits="2"
                                    :disabled="true" />
                                    <small v-if="header && !header.Nilai_Akhir_Kontrak && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('final_value_contract')) }}
                                    </small>
                            </FormField>
                          
                            
                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_PM_PIC" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_PM_PIC" :filter="true"  v-if="header"
                                    v-model="header.Username_PM_PIC" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As1, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.ADDENDUM, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_PM_PIC && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr2)" fieldName="Username_Project_Coordinator" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr2">
                                <CustomSelect name="Username_Project_Coordinator" :filter="true"  v-if="header"
                                    v-model="header.Username_Project_Coordinator" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As2, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.ADDENDUM, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Project_Coordinator && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr2)) }}
                                </small>
                            </FormField>

                            <!-- <FormField :labelName="$t('lead_engineer')" fieldName="Username_Lead_Engineering" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Username_Lead_Engineering" :filter="true"  v-if="header"
                                    v-model="header.Username_Lead_Engineering" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/username_user'"
                                    :minLength="0"
                                    :params="{job_postion : this.$UserLevel.LEAD_ENGINEER,user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.ADDENDUM, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Lead_Engineering && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('admin_pic')) }}
                                </small>
                            </FormField> -->

                            <FormField :labelName="$t(labelAppr3)" fieldName="Username_Contractor_PIC" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr3">
                                <CustomSelect name="Username_Contractor_PIC" :filter="true"  v-if="header"
                                    v-model="header.Username_Contractor_PIC" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion:header.Appr_As3, doc_type : this.$TypeDocument.ADDENDUM, contractorcode : header.Contractor_Code,companycode: header.Company_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Contractor_PIC && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr3)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr4)" fieldName="Username_Head_Unit_PIC" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr4">
                                <CustomSelect name="Username_Head_Unit_PIC" :filter="true"  v-if="header"
                                    v-model="header.Username_Head_Unit_PIC" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As4, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.ADDENDUM, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Head_Unit_PIC && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr4)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.DONE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.DONE"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.DONE)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                        </div>
                        <div class="col-6">
                            <DataTable v-if="header" :loading="!header" :value="header.Scopes ? header.Scopes : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailScope()"
                                            :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || this.hideScopes" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetailScope(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Description" :header="$t('scope')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <Textarea 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('description')" @change="onCellEditCompleteScope(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                            <br/>
                                            <small
                                                v-if="header && !slotProps.data.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div class="col-6">
                            <DataTable v-if="header" :loading="!header" :value="header.Reasons ? header.Reasons : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailReason()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetailReason(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Description" :header="$t('reason')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <Textarea 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('description')" @change="onCellEditCompleteReason(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                            <small
                                                v-if="header && !slotProps.data.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import moment from 'moment';
import IndexBase from '../Helper/IndexBase.vue'
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data() {
        return {
            indexName: "BaAddendumIndex",
            url: this.$API_URL + "baaddendum/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            reason : null,
            scope : null,
            hideScopes : false,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            labelAppr1 : "",
            labelAppr2 : "",
            labelAppr3 : "",
            labelAppr4 : "",
            submitted2 : false,
            onlyDraft: false,
        }
    },
    methods: {
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },
        inputNilaiPP(e){
            const value = typeof e.valueNumber === 'number'? e.valueNumber: e.value;
       
            var persentage = (value/this.header.Nilai_Awal_Kontrak) * 100;
            //var result = Math.trunc(persentage * 1000) / 1000;
            //var result = Math.round(persentage * 100) / 100;
            var result = Math.trunc(persentage * 100) / 100;

            if(this.header.Type_Nilai != "Cut Off"){
               this.header.Persentase_PP = result;
            }
            else{

                this.header.Persentase_Cut_Off = result;
            }
           
            if(this.header.Type_Nilai == "Penambahan")
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak + value;
            else if(this.header.Type_Nilai == "Pengurangan") 
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak - value;
            else if(this.header.Type_Nilai == "Cut Off"){
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak - value;
            }
           
            //return result;
        },
        onChangeTypeNilai(){
            this.header.Type_Persentase = this.header.Type_Nilai;
            if(this.header.Type_Nilai == "Cut Off"){
                if(this.header.Scopes.length > 0){
                    this.header.Scopes.forEach((a,i) => {
                        if (a.mode == this.$FORM_MODE_CREATE) this.header.Reasons.splice(this.header.Reasons.indexOf(i), 1);
                        else a.mode = this.$FORM_MODE_DELETE;
                    });
                }
                
                //this.header.Scopes = [];
                this.hideScopes= true;
                this.header.Persentase_PP = null;
            }else{
                this.hideScopes= false;
                this.header.Persentase_Cut_Off = null;
            }
        },
        onChangeTypePersentase(e){
            this.header.Type_Nilai = this.header.Type_Persentase;
            
            if(this.header.Type_Nilai == "Penambahan"){
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak + this.header.Nilai_PP;
                this.header.Persentase_Actual_Awal = 100;
            }
            else if(this.header.Type_Nilai == "Pengurangan") {
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak - this.header.Nilai_PP;
                this.header.Persentase_Actual_Awal = 100;
            }
            else if(this.header.Type_Nilai == "Cut Off"){
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak - this.header.Nilai_PP;
            }

            if(this.header.Type_Persentase == "Cut Off"){
                if(this.header.Scopes.length > 0){
                    this.header.Scopes.forEach((a,i) => {
                        if (a.mode == this.$FORM_MODE_CREATE) this.header.Reasons.splice(this.header.Reasons.indexOf(i), 1);
                        else a.mode = this.$FORM_MODE_DELETE;
                    });
                }
                
                //this.header.Scopes = [];
                this.header.Nilai_PP = null;
                this.hideScopes= true;
                this.header.Persentase_PP = null;
            }else{
                this.hideScopes= false;
                this.header.Persentase_Cut_Off = null;
            }
        },
        getData() {
            var self = this;
            this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode)
                .then((response) => {
                    
                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.reason = response.data.data.reason;
                    self.scope = response.data.data.scope;
                    self.detailLog = self.header.DetailLog;
                    self.hideScopes = self.header.Type_Persentase == "Cut Off";
                    if(self.mode == this.$FORM_MODE_CREATE)
                        self.header.Persentase_Actual_Awal = 100;

                    var listAppr = response.data.data.listPicAppr;
                    if(listAppr.length > 0)
                    {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.header.Appr_As1 = a.Approval_As;
                                self.header.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.header.Appr_As2 = a.Approval_As;
                                self.header.Sign_Position2 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 3){
                                self.labelAppr3 = a.Approval_As;
                                self.header.Appr_As3 = a.Approval_As;
                                self.header.Sign_Position3 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 4){
                                self.labelAppr4 = a.Approval_As;
                                self.header.Appr_As4 = a.Approval_As;
                                self.header.Sign_Position4 =  a.Sign_Position;
                            }
                        });
                    }
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            
            if(this.header){        
                this.header.Doc_Date_String = moment(this.header.Doc_Date).format('YYYY/MM/DD').toString()
            }


            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "BA Addendum has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "BA Addendum has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.submitted2 = true;
            var self = this;
            
            if(this.header.Nilai_Akhir_Kontrak < 0){
                self.showError("Error", "Cannot Submit, Final Contract Value cannot be Minus")
                return;
            }

            // if(this.header.Type_Persentase == 'Cut Off')
            //     this.header.Nilai_PP = this.Nilai_PP;
          
            //|| !this.header.Username_Admin_Project_PIC || !this.header.Username_PM_PIC || !this.header.Username_Contractor_PIC|| !this.header.Username_Head_Unit_PIC ||   !this.header.Username_Admin_Project_PIC ||
            if (!this.header.Doc_Date || !this.header.Contractor_Code || !this.header.Company_Code||!this.header.Pekerjaan ||
                !this.header.Persentase_Actual_Awal || (this.header.Persentase_PP == null && this.header.Type_Persentase != 'Cut Off') || !this.header.Nilai_Awal_Kontrak||
                !this.header.Nilai_Akhir_Kontrak || this.header.Nilai_PP == null || !this.header.Type_Persentase || 
                (this.labelAppr2 && !this.header.Username_Project_Coordinator) || (this.labelAppr1 && !this.header.Username_PM_PIC) || (this.labelAppr3 && !this.header.Username_Contractor_PIC)||
                (this.labelAppr4 && !this.header.Username_Head_Unit_PIC) || (!this.header.Persentase_Cut_Off && this.header.Type_Persentase == 'Cut Off')||
                (!this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.DONE)) {
                return;
            }
           
            // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
            //     self.showError("Error", "Must have attachment")
            //     return;
            // }   
            
            var Reasons = this.header.Reasons.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Description);
            var Scopes = this.header.Scopes.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Description);

            if(Reasons.length == 0){
                self.showError("Error", "Must have one reason")
                return;
            }
            if(Scopes.length == 0 && !this.hideScopes){
                self.showError("Error", "Must have one scope")
                return;
            }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            this.submitted2 = false;
            var self = this;

            if(this.header.Nilai_Akhir_Kontrak < 0){
                self.showError("Error", "Cannot Submit, Final Contract Value cannot be Minus")
                return;
            }
            
            // if(this.header.Type_Persentase == 'Cut Off')
            //     this.header.Nilai_PP = this.Nilai_PP;
            //|| !this.header.Username_Admin_Project_PIC || !this.header.Username_PM_PIC || !this.header.Username_Contractor_PIC|| !this.header.Username_Head_Unit_PIC   !this.header.Username_Admin_Project_PIC ||
            if (!this.header.Doc_Date || !this.header.Contractor_Code || !this.header.Company_Code||!this.header.Pekerjaan ||
                !this.header.Persentase_Actual_Awal || (this.header.Persentase_PP == null && this.header.Type_Persentase != 'Cut Off') || !this.header.Nilai_Awal_Kontrak||
                !this.header.Nilai_Akhir_Kontrak || this.header.Nilai_PP == null || !this.header.Type_Persentase ||  (!this.header.Persentase_Cut_Off && this.header.Type_Persentase == 'Cut Off')) {
                return;
            }

            // if(this.header.Reasons.length == 0){
            //     self.showError("Error", "Must have one reason")
            //     return;
            // }
            // if(this.header.Scopes.length == 0 && !this.hideScopes){
            //     self.showError("Error", "Must have one scope")
            //     return;
            // }
            // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
            //     self.showError("Error", "Must have attachment")
            //     return;
            // }   

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetailReason() {
            var newDetail = this.reason;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Reasons.push(det);
        },
        deleteDetailReason(event) {
            if (event) {
                var detail = this.header.Reasons[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Reasons.splice(this.header.Reasons.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteReason(event) {
            this.editDetailReason(event.index);
        },
        editDetailReason(index) {
            if (this.header && this.header.Reasons) {
                let mode = this.header.Reasons[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Reasons[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetailScope() {
            var newDetail = this.scope;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Scopes.push(det);
        },
        deleteDetailScope(event) {
            if (event) {
                var detail = this.header.Scopes[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Scopes.splice(this.header.Scopes.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteScope(event) {
            this.editDetailScope(event.index);
        },
        editDetailScope(index) {
            if (this.header && this.header.Scopes) {
                let mode = this.header.Scopes[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Scopes[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile(file){
            var self = this;
            this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
    },
    computed:{
        Nilai_PP(){
            var result = (this.header.Persentase_PP/ 100) * this.header.Nilai_Awal_Kontrak;
           
            if(this.header.Type_Nilai == "Penambahan")
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak + this.header.Nilai_PP;
            else if(this.header.Type_Nilai == "Pengurangan") 
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak - this.header.Nilai_PP;
            else if(this.header.Type_Nilai == "Cut Off"){
                result = ( (100/100) - (this.header.Persentase_Cut_Off/100) ) * this.header.Nilai_Awal_Kontrak
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak - result;
            }
           
            return result;
        }
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
        this.getData();
    }
}
</script>